export default {
  title: 'Zarządzaj kontem',
  buttons: {
    save: 'Zapisz',
    delete: 'Usuń',
  },
};
